<template>
    <a
        href="/slack/install-app/agile-bot"
        type="button"
        class=" bg-white shadow w-full items-center content-center hover:bg-blue-100 focus:outline-none border-blue-500 border-2 text-lg font-semibold rounded-lg rounded-full text-center font-bold py-2 px-4 rounded inline-flex justify-center">
        <img src="https://cdn.worldvectorlogo.com/logos/slack-new-logo.svg" alt="slack logo" class="w-6 h-6 mr-3">
        <span>{{ label ?? 'Add to Slack' }}</span>
    </a>
</template>

<script>
export default {
  props:['label'],
    components: {},
    data: function () {
        return {}
    },
    computed: {},
    methods: {
      open() {
            window.location.href = '/slack/install-app/agile-bot';
        }
    },
    created() {
    },
    mounted() {
        console.log('Component mounted.')
    }
}
</script>

